export const columns = [
  { key: "ord", name: "序号", fixed: true, point: 0, width: 150 },
  { key: "appName", name: "产品名称", point: 0, width: 150, fixed: true },
  { key: "osType", name: "平台", point: 0, fixed: true },
  { key: "popuStatus", name: "推广状态", point: 0, width: 120 },
  { key: "latestStatus", name: "产品最新状态", width: 150, point: 0 },
  {
    key: "totalIncre",
    name: "总新增",
    width: 120,
    sort: true,
    point: 0,
    type: "number",
  },
  {
    key: "popuIncre",
    name: "推广新增",
    width: 120,
    point: 0,
    sort: true,
  },
  {
    key: "orgIncre",
    name: "自然新增",
    point: 0,
    width: 120,
    sort: true,
  },
  {
    key: "activeUser",
    name: "活跃用户",
    point: 0,
    width: 120,
    sort: true,
  },
  {
    key: "payIncome",
    name: "内购收入",
    width: 120,
    unit: "$",
    point: 2,
    sort: true,
  },
  {
    key: "incomeTotalUSD",
    name: "变现收入",
    unit: "$",
    width: 120,
    point: 2,
    sort: true,
  },
  {
    key: "cresCost",
    name: "新增单价",
    unit: "$",
    point: 2,
    width: 120,
    sort: true,
    tip: "支出总计/总新增",
  },
  {
    key: "popCost",
    name: "推广单价",
    unit: "$",
    point: 0,
    width: 120,
    sort: true,
    tip: "支出总计/推广新增",
  },
  {
    key: "arpu",
    name: "变现活跃ARPU",
    unit: "$",
    point: 3,
    width: 170,
    sort: true,
    tip: "变现收入/活跃用户",
  },
  {
    key: "allTotalIncome",
    name: "收入总计",
    unit: "$",
    point: 2,
    width: 120,
    sort: true,
  },
  {
    key: "popTotalUSD",
    name: "推广总计",
    unit: "$",
    point: 2,
    width: 120,
    sort: true,
  },
  {
    key: "roiTotal",
    name: "总ROI",
    point: 2,
    width: 120,
    percent: "%",
    sort: true,
    tip: "（累计 ）收入/支出 ，以一个固定值形式呈现",
  },
];
export const osTypeFu = (num) => {
  switch (num) {
    case 1:
      return "android";
    case 2:
      return "google";
    case 3:
      return "ios";
    default:
      return "-";
  }
};